import { useTranslation } from 'react-i18next';
import Currencies from '../../../Core/Enums/Currencies';
import { addVat } from '../../../Core/Services/PaymentService';

export default function LevelSelection({
  selectedSize,
  selectedLevel,
  setSelectedLevel,
}) {
  const { t, i18n } = useTranslation();

  return (
    <div className="!border !border-solid border-gray-300 p-6 mt-6">
      <div className="flex justify-between items-center">
        <div className="flex">
          <input
            style={{
              accentColor: '#233F72',
              width: '20px',
              height: '20px',
              marginRight: '8px',
            }}
            type="radio"
            name={'level' + Math.random()}
            checked={selectedLevel === 0}
            disabled={
              selectedSize.levelPrice[0] == null ||
              selectedSize.levelPrice[0] == 0
            }
            onChange={() => setSelectedLevel(0)}
          />
          <div className="font-bold text-sm">{t('ground_floor')}</div>
          <div className="text-sm">
            {selectedSize &&
            selectedSize.levelPrice &&
            selectedSize.levelPrice[0] ? (
              <>
                :{' '}
                {t('container_from_price', {
                  price: addVat(selectedSize.levelPrice[0]).toLocaleString(
                    i18n.language,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  ),
                  currency: Currencies.getCodeByValue(selectedSize.currency),
                })}
              </>
            ) : (
              <span className="text-gray-400 ml-1">
                {t('no_units_available')}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="flex mt-3">
        {selectedSize && selectedSize.levelAmount > 1 && (
          <>
            <input
              style={{
                accentColor: '#233F72',
                width: '20px',
                height: '20px',
                marginRight: '8px',
              }}
              type="radio"
              name={'level' + Math.random()}
              checked={selectedLevel == 1}
              disabled={
                selectedSize.levelPrice[1] == null ||
                selectedSize.levelPrice[1] == 0
              }
              onChange={() => setSelectedLevel(1)}
            />
            <div className="font-bold text-sm">
              {selectedSize.levelAmount - 1} {t('floor')}
            </div>
            <div className="text-sm">
              {selectedSize &&
              selectedSize.levelPrice &&
              selectedSize.levelPrice[1] ? (
                <>
                  :{' '}
                  {t('container_from_price', {
                    price: addVat(selectedSize.levelPrice[1]).toLocaleString(
                      i18n.language,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    ),
                    currency: Currencies.getCodeByValue(selectedSize.currency),
                  })}
                </>
              ) : (
                <span className="text-gray-400 ml-1">
                  {t('no_units_available')}
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
